export default __webpack_public_path__ + "static/media/our-process-04.823e4491.jpg";